import { render, staticRenderFns } from "./ConferenceRoomNavigation.vue?vue&type=template&id=0b8fa338&scoped=true"
import script from "./ConferenceRoomNavigation.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomNavigation.vue?vue&type=script&lang=js"
import style0 from "./ConferenceRoomNavigation.vue?vue&type=style&index=0&id=0b8fa338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fa338",
  null
  
)

export default component.exports